import {Box, Typography} from '@mui/material';
import ArrModal from '../../../../../../common/arr-modal/ArrModal';
import {t} from 'i18next';
import './ReplaceManualContentModal.scss';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../../../../../redux/store';
import {AI_REVIEW_JOB_TYPE} from '../../../../constant/AiReviewConstants';
import {
  resetEditMode,
  setDefineCriteria,
} from '../../../../../../../redux/slice/aiReviewSlice';
import {CRITERIA} from '../IssueCodingTypeHeader';

interface ReplaceManualContentModalProps {
  open: boolean;
  onClose: () => void;
  handleUseSavedProtocol: () => void;
  setShowReplaceManualModal: (val: boolean) => void;
}
const ReplaceManualContentModal = ({
  open,
  onClose,
  handleUseSavedProtocol,
  setShowReplaceManualModal,
}: ReplaceManualContentModalProps) => {
  const jobType = useSelector((state: RootState) => state.aiReview.jobType);

  const dispatch = useDispatch();
  const handleConfirm = () => {
    handleUseSavedProtocol();
    dispatch(setDefineCriteria(CRITERIA.SAVED));
    dispatch(resetEditMode());
    setShowReplaceManualModal(false);
  };

  return (
    <>
      <ArrModal
        className="arr-review-replace-manual-content-modal"
        showModal={open}
        onClose={onClose}
        showClose={false}
        title={t(
          'ai.review.protocolIntelligence.replaceManualContentModalTitle'
        )}
        aria-label={t(
          'ai.review.protocolIntelligence.replaceManualContentModalTitle'
        )}
        dataTestId="replace-manual-content-modal"
        buttons={[
          {
            id: 'cancel-btn',
            label: t('ai.review.leftPanel.cancelBtn'),
            onClick: onClose,
            variant: 'secondary',
            dataTestId: 'rmc-cancel-button',
            className: 'cancel-button',
          },
          {
            id: 'use-saved-protocol-btn',
            label: t('ai.review.protocolIntelligence.useSavedProtocolBtn'),
            onClick: handleConfirm,
            variant: 'primary',
            dataTestId: 'use-saved-protocol-btn',
            className: 'use-saved-protocol-btn',
          },
        ]}
      >
        <Box className="replace-manual-content-modal-description">
          <Typography
            className=" typo-text body2_size"
            tabIndex={0}
            data-testid={`replace-manual-content-modal-text`}
          >
            {jobType === AI_REVIEW_JOB_TYPE.issueCoding
              ? t(
                  'ai.review.protocolIntelligence.replaceManualContentModalDesc'
                )
              : t(
                  'ai.review.protocolIntelligence.replaceManualContentModalDesc2'
                )}
          </Typography>
          <Typography
            className="typo-text body2_size"
            tabIndex={0}
            data-testid={`replace-manual-content-modal-replace-manual-content-modal-footer`}
          >
            {t(
              'ai.review.protocolIntelligence.replaceManualContentModalFooter'
            )}
          </Typography>
        </Box>
      </ArrModal>
    </>
  );
};

export default ReplaceManualContentModal;
